import { Pipe, PipeTransform } from '@angular/core';
import { School } from '../models/school';

@Pipe({
    name: 'schoolFilter',
    pure: false,
    standalone: false
})

export class SchoolFilterPipe implements PipeTransform {
    transform(items: School[], args: any[]): any[] {
        const counter = args[1];
        const filter = args[0];
        let filteredList = items;
        if (!items || !filter) {
            return items;
        }
        const searchText = filter.SearchText.toLowerCase();
        if (searchText.length) {
            filteredList = items.filter(school => (school.school_name.toLowerCase().indexOf(searchText) !== -1));
        }

        if (counter) {
            counter.count = filteredList.length;
        }
        return filteredList;
    }
}
